import { TelemetryGenericEnum } from 'src/app/shared/enums';
import {TrackingUtilsService} from './tracking-utils.service';
import {analyticsConstants, constants} from '../../constants';
import {GlobalAnalyticsVariablesInterface} from '../interfaces';
import { getCountryCode } from 'src/app/util';

export const trackGlobalVariablesPayloadCase = (
  trackingUtilsService: TrackingUtilsService
): GlobalAnalyticsVariablesInterface => {
  const guestData = trackingUtilsService.getGuestData();
  const countryOfResidence = trackingUtilsService.countryOfResidence;
  return {
    vdsId: trackingUtilsService.getVdsId(),
    brand: trackingUtilsService.getBrandCode(),
    country: getCountryCode() ?? analyticsConstants.DEFAULT_COUNTRY,
    countryOfResidence: countryOfResidence,
    cruiseLength: guestData?.sailingDays ?? TelemetryGenericEnum.EMPTY_VALUE,
    cruiseBookingId: guestData?.bookingId ?? TelemetryGenericEnum.EMPTY_VALUE,
    daysToCruise: guestData?.daysLeft ?? 0,
    departureDate: guestData?.departureDate ?? TelemetryGenericEnum.EMPTY_VALUE,
    itinerary: '',
    language: trackingUtilsService.getCurrentLanguageCode().toLowerCase() ?? analyticsConstants.DEFAULT_LANGUAGE,
    loginStatus: constants.LOGIN_STATUS.LOGGED_IN,
    passengerId: retrievePassengerId(guestData?.passengerId, guestData?.loggedInPaxId),
    ship: guestData?.shipName ?? TelemetryGenericEnum.EMPTY_VALUE,
    shipCode: trackingUtilsService.getSimplifiedShipName(),
    channel: analyticsConstants.CHANNEL,
    voyageId: trackingUtilsService.getSimplifiedShipName() + trackingUtilsService.getDateNoDashes(),
    currency: analyticsConstants.DEFAULT_CURRENCY,
    appName: analyticsConstants.APP_NAME,
  };
}

export const retrievePassengerId = (
  passengerId?: string | number,
  loggedInPaxId?: string | number
): string => {
  if (passengerId) return passengerId.toString();
  return loggedInPaxId ? loggedInPaxId.toString() : constants.DEFAULT_GUEST_ID_FOR_TRACKING.ID;
}
